import React, { useState, useEffect } from 'react';
import { Content, Page } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';

const BOOKINGS_URL = "https://outlook.office365.com/owa/calendar/syntonize1@syntonize.com/bookings/";

const useStyles = makeStyles(theme => ({
  contentContainer: {
    height: 'calc(100vh - 120px)',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    position: 'relative',
    overflow: 'hidden',
  },
  iframeContainer: {
    width: '100%',
    maxWidth: '1000px',
    height: '750px',
    margin: '0 auto',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    borderRadius: '4px',
  },
  imageContainer: {
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    width: '100px',
    height: '100px',
    overflow: 'hidden',
    borderRadius: '4px',
    transition: 'all 0.3s ease',
    zIndex: 0,
    cursor: 'pointer',
  },
  imageContainerZoomed: {
    width: '600px',
    height: '600px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 2,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  browserMessage: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

const Reservation = () => {
  const classes = useStyles();
  const [isZoomed, setIsZoomed] = useState(false);
  const [needsDirectLink, setNeedsDirectLink] = useState(false);
  const [browserName, setBrowserName] = useState('');

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isFirefox = userAgent.indexOf('firefox') > -1;
    const isIE = /msie|trident/.test(userAgent);
    const isEdge = userAgent.indexOf('edg') > -1;

    if (isFirefox || isIE || isEdge) {
      setNeedsDirectLink(true);
      setBrowserName(isFirefox ? 'Firefox' : (isIE ? 'Internet Explorer' : 'Microsoft Edge'));
    }
  }, []);

  const handleImageClick = () => {
    setIsZoomed(!isZoomed);
  };

  const openInNewTab = () => {
    window.open(BOOKINGS_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Page themeId="tool">
      <Content>
        <div className={classes.contentContainer}>
          <div className={classes.iframeContainer}>
            {needsDirectLink ? (
              <>
                <Typography variant="h6" className={classes.browserMessage}>
                  For the best experience in {browserName}, please use the direct link:
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={openInNewTab}
                  className={classes.button}
                >
                  Open Reservation Calendar
                </Button>
              </>
            ) : (
              <iframe 
                src={BOOKINGS_URL}
                className={classes.iframe}
                title="Syntonize Bookings"
                frameBorder="0"
              />
            )}
          </div>

          <div
            className={`${classes.imageContainer} ${
              isZoomed ? classes.imageContainerZoomed : ''
            }`}
            onClick={handleImageClick}
          >
            <img 
              src="/syntonize_office_map.png"
              alt="Syntonize Office Map" 
              className={classes.image} 
            />
          </div>
        </div>
      </Content>
    </Page>
  );
};

export default Reservation;